import { useCallback } from 'react'

export const useToFileSize = () => {
  return useCallback((sizeInBytes: number) => {
    if (sizeInBytes < 1024 * 1024) {
      const kbsize = Math.round(sizeInBytes / 1024)
      return `${kbsize} KB`
    }
    const mbSize = (sizeInBytes / (1024 * 1024)).toFixed(2)
    const fixedMbSize = mbSize.endsWith('.00') ? mbSize.slice(0, -3) : mbSize.endsWith('0') ? mbSize.slice(0, -1) : mbSize
    return `${fixedMbSize} MB`
  }, [])
}
